module.exports = function (fox) {
	var FormElementBase = require('../base')(fox);
	
	if (typeof NodeList !== 'undefined' && !NodeList.prototype.forEach) {
		NodeList.prototype.forEach = function () {
			return Array.prototype.forEach.apply(this, arguments);
		};
	}

	return fox.extend({
		__constructor: function () {
			this.super('__constructor', arguments);

			if (!('selector' in this.params) && this.key) {
				this.params.selector = '[name^=' + this.key + ']';
			}
		},

		init: function () {
			this.form = this.formLayer.getFormDomNode();

			var initResult = this.super('init', arguments);
			var nodes = this.nodes = this.getNodes();

			if (!nodes.length) {
				throw new Error("Can't find dom node by selector: " + this.params.selector);
			}

			this.value = '';

			return initResult;
		},

		getNodes: function () {
			return this.womContainer ?
				this.womContainer.dom(this.params.selector) :
				this.form.querySelectorAll(this.params.selector);
		},

		registerEventCallbacks: function () {
			var _this = this;

			this.nodes.forEach(function (node) {
				_this.formLayer.addDomHandler({
					event: 'invalid',
					target: node,
					callback: function (el, alias, p, event) {
						event.preventDefault();

						return false;
					}
				});

				_this.formLayer.addDomHandler({
					event: 'change',
					target: node,
					callback: _this._onChange.bind(_this)
				});
			});
		},

		_onChange: function () {
			var value = this.getValue();
			
			function dispatch (value) {
				return this.dispatchEvent('change', {value: value});
			};

			if (fox.isPromise(value)) {
				return value.then(dispatch.bind(this));
			}
			
			return dispatch.call(this, value);
		},

		validate: function () {
			var result = Array.prototype.every.call(this.nodes, function (node) {
				if (node.validity)
					return node.validity.valid;
					
				return true;
			});

			if (!result)
				return this._returnValidateResult(result);

			var parentResult = this.super('validate', arguments);

			if (fox.isPromise(parentResult)) {
				return parentResult.then(function (resp) {
					return fox.merge(resp, this._returnValidateResult(resp.result && result));
				}.bind(this));
			}

			return this._returnValidateResult(result);
		},

		disable: function () {
			this.nodes.forEach(function (node) {
				if ('disabled' in node) {
					node.disabled = true;
				}
			});

			return this.super('disable', arguments);
		},

		enable: function () {
			this.nodes.forEach(function (node) {
				if ('disabled' in node) {
					node.disabled = false;
				}
			});

			return this.super('enable', arguments);
		},

		getValue: function () {
			if (!this.value) this.value = '';

			return this.super('getValue', arguments);
		}
	}, FormElementBase, null, 'FormElementDomBase');
};


//////////////////
// WEBPACK FOOTER
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/node_modules/fox-core-resource/lib/widgets/newForm/elements/dom/base.js
// module id = 22
// module chunks = 0